export default __webpack_public_path__ + "static/media/mementooo.9bca8b2c.png";